import { ISchedule } from '../../../../types/schedule'
import styles from '../ScheduleItem.module.scss'
import { generateScheduleSummary } from '../../lib/generateScheduleSummary'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import { selectOneProductUtcOffset } from '../../../../store/selectors/productsUtcOffsetSelectors'

interface ScheduleSummaryProps {
    guid: string
    schedule: ISchedule
}

export const ScheduleSummary = (props: ScheduleSummaryProps) => {
    const { guid, schedule } = props
    const productUtcOffset = useAppSelector(selectOneProductUtcOffset(guid))
    const summary = generateScheduleSummary(schedule, productUtcOffset)

    return <div className={`px-4 ${styles.summary}`}>{summary}</div>
}
